import { ReactComponent as CheckIcon } from '../../MultiSelect/checkIcon.svg'
import css from './styles.module.scss'
import classnames from 'classnames/bind'

const cx = classnames.bind(css)

const Checkbox = ({ isChecked }) => {
  return (
    <span className={cx(css.box, { [css.checked]: isChecked })}>
      <CheckIcon className={css.checkIcon} />
    </span>
  )
}

export default Checkbox
